import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PDFDocument } from 'pdf-lib';
import * as moment from 'moment';
import { getImageAsEmbedNew, removeNonAllowedCharactersFromPDF, urlToArrayBuffer } from 'src/app/utils/utils.common';
import { urls } from 'src/app/utils/url-utils';
import { AuthService } from 'src/app/service/auth-service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class DriverGrievanceService {

  constructor(
    private http: HttpClient,
     private authService: AuthService
  ) { }

  getDriverGrievance(): Observable<any> {
    let params = new HttpParams();
    params = params.append('type', 'grievance');
    params = params.append('type', 'itemlost');
    return this.http.get<any>(urls.BASE_URL + urls.DRIVERS_GRIEVANCE, { params })

  }


  getDriverGrievanceById(id): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.DRIVERS_GRIEVANCE + '/' + id)
  }


  async getDriverGrivenceReport(payload, user, loader) {
    try {
      const response = await fetch('assets/documents/driver-grievance-report.pdf');
      let pdfBuffer = await response.arrayBuffer();

      pdfBuffer = await this.fillPDF(pdfBuffer, payload, user);

      if (pdfBuffer) {
        const blob = new Blob([pdfBuffer], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        if (payload && payload.grievance && payload.grievance.type == 'grievance') {
          a.download = `driver-grievance-${payload.grievance._id ? payload.grievance._id.slice(0, 6) : 'report'}.pdf`;
        } else {
          a.download = `itemlost-${payload && payload.grievance && payload.grievance._id ? payload.grievance._id.slice(0, 6) : 'report'}.pdf`;
        }

        a.click();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error('Error generating driver grievance report:', error);
    } finally {
      if (loader) {
        loader.isloading = false;
      }
    }
  }


  async fillPDF(pdfBuffer: ArrayBuffer, payload, user): Promise<ArrayBuffer> {
    let jobAcceptedUrl;
    let jobOnSceneUrl;
    let jobStartedUrl;
    let jobEndedUrl;

    if (payload && payload.job && payload.job.trackInfoJob) {
      if (payload.job.trackInfoJob.jobAccepted && payload.job.trackInfoJob.jobAccepted.coords) {
        jobAcceptedUrl = await this.loadStaticMap(payload.job.trackInfoJob.jobAccepted.coords[1],
          payload.job.trackInfoJob.jobAccepted.coords[0]);
      }
      if (payload.job.trackInfoJob.jobArrived && payload.job.trackInfoJob.jobArrived.coords) {
        jobOnSceneUrl = await this.loadStaticMap(payload.job.trackInfoJob.jobArrived.coords[1],
          payload.job.trackInfoJob.jobArrived.coords[0]);
      }
      if (payload.job.trackInfoJob.jobStarted && payload.job.trackInfoJob.jobStarted.coords) {
        jobStartedUrl = await this.loadStaticMap(payload.job.trackInfoJob.jobStarted.coords[1],
          payload.job.trackInfoJob.jobStarted.coords[0]);
      }
      const endTrack = payload.job.trackInfoJob.jobCompleted || payload.job.trackInfoJob.jobFinished;
      if (endTrack && endTrack.coords) {
        jobEndedUrl = await this.loadStaticMap(endTrack.coords[1], endTrack.coords[0]);
      }
    }

    const pdfDoc = await PDFDocument.load(pdfBuffer);
    const form = pdfDoc.getForm();

    const profileLogo: any = (user && user.profileImageURL) ? await urlToArrayBuffer(user.profileImageURL) : null;
    const companyLogo = profileLogo ? await getImageAsEmbedNew(pdfDoc, user.profileImageURL, profileLogo) : null;

    const signatureUrl = payload && payload.driver ? payload.driver.driverSignatureImage : null;
    const signature: any = signatureUrl ? await urlToArrayBuffer(signatureUrl) : null;
    const driverSignature = signature ? await getImageAsEmbedNew(pdfDoc, signatureUrl, signature) : null;

    //Reporting Details
    form.getTextField('company_name').setText(user && user.displayName ? user.displayName : '');
    form.getTextField('report_name').setText(payload && payload.grievance && payload.grievance.type == 'grievance' ? 'DRIVER GRIEVANCE REPORT' : 'DRIVER ITEM LOST REPORT');
    if (companyLogo) {
      form.getTextField('company_logo').setImage(companyLogo);
    }
    form.getTextField('dos').setText(payload && payload.job && payload.job.scheduleTime ? moment(payload.job.scheduleTime).format('MM/DD/YY HH:mm') : '');
    form.getTextField('reporting_time').setText(payload && payload.grievance && payload.grievance.updatedAt ? moment(payload.grievance.updatedAt).format('MM/DD/YY HH:mm') : '');
    form.getTextField('complaint_id').setText(payload && payload.grievance && payload.grievance._id ? payload.grievance._id : '');
    form.getTextField('reported_driver').setText(payload && payload.driver && payload.driver.displayName ? payload.driver.displayName.toString() : '');

    if (payload && payload.grievance && payload.grievance.incidentAddress) {
      form.getTextField('incident_address').setText(payload.grievance.incidentAddress.toString());
    }

    // Member
    const priorityClient = payload && payload.assign ? payload.assign.priorityClient : null;
    form.getTextField('member_name').setText(priorityClient && priorityClient.displayName ? priorityClient.displayName.toString() : '');
    form.getTextField('member_cellphone').setText(priorityClient && priorityClient.cellPhone ? priorityClient.cellPhone.toString() : '');
    form.getTextField('member_contactNo').setText(priorityClient && priorityClient.contactNumber ? priorityClient.contactNumber.toString() : '');
    form.getTextField('client_id').setText(priorityClient && priorityClient.clientId ? priorityClient.clientId.toString() : '');
    if (payload && payload.assign && payload.assign.weight) {
      form.getTextField('member_weight').setText(payload.assign.weight.toString());
    }
    form.getTextField('member_gender').setText(payload && payload.assign && payload.assign.gender ? payload.assign.gender : '');
    form.getTextField('insurance_id').setText(payload && payload.assign && payload.assign.memberId ? payload.assign.memberId.toString() : '');
    form.getTextField('member_dob').setText(payload && payload.assign && payload.assign.dob ? payload.assign.dob.toString() : '');
    form.getTextField('member_escort').setText(payload && payload.job && payload.job.escortName ? payload.job.escortName.toString() : '');

    // Trip Infomation
    form.getTextField('pu_address').setText(payload && payload.job && payload.job.jobOriginAddress ? payload.job.jobOriginAddress.toString() : '');
    form.getTextField('do_address').setText(payload && payload.job && payload.job.jobDestinationAddress ? payload.job.jobDestinationAddress.toString() : '');
    form.getTextField('trip_status').setText(payload && payload.job && payload.job.jobStatus ? payload.job.jobStatus.toString() : '');
    const companyNote = payload && payload.job && payload.job.noteInfoJob ? payload.job.noteInfoJob.companyNote : null;
    form.getTextField('trip_notes').setText(companyNote ? companyNote.slice(0, 50) : '');
    form.getTextField('trip_miles').setText(payload && payload.job && payload.job.milage !== undefined && payload.job.milage !== null ? payload.job.milage.toString() : '');
    form.getTextField('pu_time').setText(payload && payload.job && payload.job.scheduleTime ? moment(payload.job.scheduleTime).format('MM/DD/YY HH:mm') : '');
    form.getTextField('do_time').setText(payload && payload.job && payload.job.appointmentTime ? moment(payload.job.appointmentTime).format('MM/DD/YY HH:mm') : '');
    
    const trackInfo = payload && payload.job ? payload.job.trackInfoJob : null;
    const jobArrived = trackInfo ? trackInfo.jobArrived : null;
    const jobFinished = trackInfo ? (trackInfo.jobFinished || trackInfo.jobCompleted) : null;
    const jobAccepted = trackInfo ? trackInfo.jobAccepted : null;
    const jobStarted = trackInfo ? trackInfo.jobStarted : null;

    form.getTextField('act_pu_time').setText(jobArrived && jobArrived.time ? moment(jobArrived.time).format('MM/DD/YY HH:mm') : '');
    form.getTextField('act_do_time').setText(jobFinished && jobFinished.time ? moment(jobFinished.time).format('MM/DD/YY HH:mm') : '');
    
    if (payload && payload.assign && payload.assign.payor) {
      form.getTextField('broker_name').setText(payload.assign.payor.toString());
    }

    form.getTextField('trip_id').setText(payload && payload.assign && payload.assign.tripId ? payload.assign.tripId.toString() : '');
    form.getTextField('los').setText(payload && payload.job && payload.job.tripRequirement ? payload.job.tripRequirement.toString() : '');

    // timestamps
    form.getTextField('accepted_time').setText(jobAccepted && jobAccepted.coords && jobAccepted.coords[0] !== 0 && jobAccepted.time ? moment(jobAccepted.time).format('MM/DD/YY HH:mm') : '');
    form.getTextField('onscene_time').setText(jobArrived && jobArrived.coords && jobArrived.coords[0] !== 0 && jobArrived.time ? moment(jobArrived.time).format('MM/DD/YY HH:mm') : '');
    form.getTextField('started_time').setText(jobStarted && jobStarted.coords && jobStarted.coords[0] !== 0 && jobStarted.time ? moment(jobStarted.time).format('MM/DD/YY HH:mm') : '');
    form.getTextField('ended_time').setText(jobFinished && jobFinished.coords && jobFinished.coords[0] !== 0 && jobFinished.time ? moment(jobFinished.time).format('MM/DD/YY HH:mm') : '');

    form.getTextField('accepted_coordinate').setText(jobAccepted && jobAccepted.coords && jobAccepted.coords[0] !== 0 ? `${jobAccepted.coords[0]} - ${jobAccepted.coords[1]}` : '');
    form.getTextField('onscene_coordinate').setText(jobArrived && jobArrived.coords && jobArrived.coords[0] !== 0 ? `${jobArrived.coords[0]} - ${jobArrived.coords[1]}` : '');
    form.getTextField('started_coordinate').setText(jobStarted && jobStarted.coords && jobStarted.coords[0] !== 0 ? `${jobStarted.coords[0]} - ${jobStarted.coords[1]}` : '');
    form.getTextField('ended_coordinate').setText(jobFinished && jobFinished.coords && jobFinished.coords[0] !== 0 ? `${jobFinished.coords[0]} - ${jobFinished.coords[1]}` : '');

    const comments = payload && payload.grievance ? (payload.grievance.comments || payload.grievance.description || '') : '';
    form.getTextField('driver_grievance').setText(comments ? comments.toString() : '');
    if (driverSignature) {
      form.getTextField('driver_signature').setImage(driverSignature);
    }

    // remove non ASCII
    await removeNonAllowedCharactersFromPDF(form);
    const modifiedBuffer = await pdfDoc.save(); // Save the modified PDF back to a buffer
    return modifiedBuffer;


  }

  loadStaticMap = async (lat, lng) => {
    let mapKey = '';
    const res = await this.authService.getGoogleKeys().toPromise();
    if (res && res.key) {
      console.log('Load static map API key:');
      mapKey = res.key;
    } else {
      console.error('Error load static map API key');
    }
    let url = 'https://maps.googleapis.com/maps/api/staticmap?center='
      + lat + ',' + lng + '&zoom=18&size=500x500&maptype=satellite&markers=color:red|' + lat
      + ',' + lng + '&key=' + mapKey;

    return url;
  }



}
